import { ISiteRouter } from '@/ISiteRouter';
import Base from './Base.vue';
import MyIP from './MyIP.vue';

const comingSoonEnabled = true;
const headerConfig = {
  colorClass: 'grey',
  iColorClass: 'b-blue',
  foreground: '#FFFFFF',
  items: [
    {
      url: '/',
      name: 'Home',
    },
    {
      url: '/ContactUs',
      name: 'Contact Us',
    },
    {
      url: '/MyIP',
      name: 'What\'s my IP',
    },

    {
      url: 'https://bettercorp.co.za/',
      name: 'BetterCorp',
    },
  ],
  logo: {
    url: '/img/svgs/BetterWebsite-BetterMarketing.svg',
    width: 150,
    height: 60,
  },
};
const footerConfig = {
  socialIcons: [
    {
      url: 'https://fb.com/BetterCorp',
      icon: 'fa fa-facebook',
    },
  ],
};
const thisHostname = 'networks.bettercorp.co.za';

export default {
  config: {
    companyName: 'BetterNetworks',
    companyThemeColour: 'rgb(33, 33, 33)',
    companyDescription: 'BetterCorp is a services company here to better your life.',
    companyKeywords: ['bettercorp', 'services', 'south africa', 'better', 'ninja', 'betterninja', 'betterweb'],
    companyIcons: {
      'Large': '/bcorp-icons/apple-icon.png',
      '192x192': '/bcorp-icons/android-icon-192x192.png',
      '76x76': '/bcorp-icons/apple-icon-76x76.png',
      '120x120': '/bcorp-icons/apple-icon-120x120.png',
      '152x152': '/bcorp-icons/apple-icon-152x152.png',
      '310x310': '/bcorp-icons/ms-icon-310x310.png',
      '70x70': '/bcorp-icons/ms-icon-70x70.png',
      '150x150': '/bcorp-icons/ms-icon-150x150.png',
    },
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('./Home.vue'),
      meta: {
        host: thisHostname,
        comingSoon: comingSoonEnabled,
        base: Base,
        headerConfig: {
          hideOnInitial: true,
          ...headerConfig,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
    {
      path: '/Partners',
      name: 'Partners',
      component: () => import('./Partners.vue'),
      meta: {
        host: thisHostname,
        comingSoon: comingSoonEnabled,
        base: Base,
        headerConfig: {
          hideOnInitial: false,
          ...headerConfig,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      component: () => import('./ContactUs.vue'),
      meta: {
        host: thisHostname,
        comingSoon: comingSoonEnabled,
        base: Base,
        headerConfig: {
          hideOnInitial: false,
          ...headerConfig,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
    {
      path: '/MyIP',
      name: 'MyIP',
      component: MyIP,
      meta: {
        host: thisHostname,
        comingSoon: comingSoonEnabled,
        base: Base,
        headerConfig: {
          hideOnInitial: false,
          ...headerConfig,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
    // {
    //   path: '/Portal/Login',
    //   name: 'Portal Login',
    //   component: () => import('./PortalLogin.vue'),
    //   meta: {
    //     host: thisHostname,
    //     comingSoon: comingSoonEnabled,
    //     base: Base,
    //     headerConfig: {
    //       hideOnInitial: false,
    //       ...headerConfig,
    //     },
    //   },
    // },
    {
      path: '*',
      name: 'Not found',
      component: () => import('./Home.vue'),
      meta: {
        host: thisHostname,
        comingSoon: comingSoonEnabled,
        base: Base,
        headerConfig: {
          hideOnInitial: false,
          ...headerConfig,
        },
        footerConfig: {
          ...footerConfig,
        },
      },
    },
  ],
} as ISiteRouter;
